export default __webpack_public_path__ + "static/media/coresanscr85-webfont.01f228c3.woff";